// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';

class Field extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick(event) {
    this.props.handleClick(event);
  }
  
  render() {
    const { customClasses, iconRight, iconLeft, children, disabled } = this.props;
    
    return (
      <div
        className={`filter-v2__field ${customClasses}`}
        onClick={this.handleClick}
        data-disabled={disabled}
      >
        { iconLeft && <i className={`icon icon-${iconLeft}`} />}
        { children }
        { iconRight && <i className={`icon icon-${iconRight}`} />}
      </div>
    );
  }
}

Field.defaultProps = {
  customClasses: '',
  iconRight: '',
  iconLeft: '',
  children: null,
  handleClick: () => {},
  disabled: false,
};

Field.propTypes = {
  customClasses: PropTypes.string,
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  children: PropTypes.element,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Field;
